"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductSearchGrid = void 0;
var GenericFunctions = require("./generic-functions");
var queryString = require('query-string');
var api_constants_1 = require("./constants/api-constants");
var constants_1 = require("./constants/constants");
var router_1 = require("./router");
var bookmarked_products_page_1 = require("./pages/bookmarked-products-page");
var mobile_breadcrumb_1 = require("./mobile-breadcrumb");
require("../css/product-search-grid.scss");
var IframeComms = require("./frame-comms/iframe-comms");
var features_filter_bar_mobile_1 = require("./features-filter-bar-mobile");
var ProductSearchGrid = /** @class */ (function () {
    function ProductSearchGrid() {
    }
    ProductSearchGrid.loadDataGrid = function (memberNr, categoryId, query) {
        //set the type of refresh: Full view or only the next page
        if (query == undefined) {
            query = {};
        }
        ;
        if (query.hasOwnProperty("page")) { //only the first time
            query.UpdateAll = false;
            $(ProductSearchGrid.productListResultsIdSelector).hide();
        }
        else {
            query.UpdateAll = true;
            $("#product-search-results-container").html("");
        }
        //get the products
        $(ProductSearchGrid.productListResultsIdSelector).html("");
        GenericFunctions.addLoadingIcon("#product-search-results-container");
        var qs = "?" + queryString.stringify(query);
        var promise = $.get({
            url: window.BaseUrlWithVersions + "/" + api_constants_1.ApiConstants.ProductSearchBase + "/" + categoryId + "/" + api_constants_1.ApiConstants.ProductSearchProducts + qs,
        });
        promise.done(function (data) {
            var callBack = function () {
                if (query.UpdateAll) {
                    $("#product-search-results-container").html(data);
                    ProductSearchGrid.initGrid(memberNr, query.UpdateAll);
                }
                else {
                    $(ProductSearchGrid.productListResultsIdSelector).html($(data).filter(function (i, e) { return e.id == "product-list-results"; }).html());
                    $(ProductSearchGrid.productListResultsIdSelector).show();
                    ProductSearchGrid.initGrid(memberNr, query.UpdateAll);
                    //set status
                    ProductSearchGrid.setStatus();
                }
            };
            GenericFunctions.ajaxResponseRedirectIfNeeded(data, callBack);
        });
        promise.fail(function () {
            GenericFunctions.showErrorMessage(constants_1.Constants.ErrorGettingMarkedProducts);
        });
        promise.always(function () {
            GenericFunctions.removeLoadingIcon("#product-search-results-container");
            IframeComms.propagateHeight(false);
        });
    };
    ProductSearchGrid.initPagination = function () {
        //pagination configuration
        var parsedQueryString = queryString.parse(location.search);
        var currentPage = (parsedQueryString.page != undefined ? parsedQueryString.page : 1);
        delete parsedQueryString.page;
        var qs = queryString.stringify(parsedQueryString);
        qs = qs.length == 0 ? (qs + "page=") : (qs + "&page=");
        qs = "?" + qs;
        //total products
        var totalProducts = parseInt($("#total-results-search span").text());
        $('#product-search-navigation').pagination({
            items: totalProducts,
            itemsOnPage: $('#product-search-navigation').data("products-per-page"),
            currentPage: currentPage,
            cssStyle: '',
            prevText: '<span aria-hidden="true">&laquo;</span>',
            nextText: '<span aria-hidden="true">&raquo;</span>',
            hrefTextPrefix: qs,
            onInit: function () {
            },
            onPageClick: function (page, evt) {
                evt.preventDefault();
                router_1.Router.clickHandler(evt);
            }
        });
    };
    ProductSearchGrid.initGrid = function (memberNr, generatePagination) {
        if (generatePagination) {
            ProductSearchGrid.initPagination();
        }
        //grid events
        $(ProductSearchGrid.productListResultsIdSelector + " .no-marked-product-item").on("click", function (e) {
            var productId = $(this).data("product-id").toString();
            $(this).parent().addClass("marked");
            bookmarked_products_page_1.BookMarkedProducts.addMarkedProductToLocalStorage(memberNr, productId);
            //marked products
            ProductSearchGrid.markedProductsButtonUpdateCounter(memberNr);
        });
        $(ProductSearchGrid.productListResultsIdSelector + " .marked-product-item").on("click", function (e) {
            var productId = $(this).data("product-id").toString();
            $(this).parent().removeClass("marked");
            bookmarked_products_page_1.BookMarkedProducts.loadAndRemoveMarkedProductFromLocalStorage(memberNr, productId);
            //marked products
            ProductSearchGrid.markedProductsButtonUpdateCounter(memberNr);
        });
        //If there are not products we reload to other page
        if ($(ProductSearchGrid.productListResultsIdSelector + " .product-item").children().length == 0) {
            var appCallback = function () {
                var url = window.BaseUrlWithVersions;
                History.pushState({}, url, url);
                $("#generic-info-modal #info-text").text(constants_1.Constants.BadProductSearchParams);
                $("#generic-info-modal").modal("show");
            };
            var firstNavigationCallback = function () {
                appCallback();
            };
            GenericFunctions.redirectCallbacks(firstNavigationCallback, appCallback);
        }
        //marked products
        var favoriteProducts = bookmarked_products_page_1.BookMarkedProducts.loadAndGetMarkedProductsFromStorage(memberNr);
        favoriteProducts.forEach(function (e) {
            $(".marked-product-item[data-product-id=" + e + "]").parent().addClass("marked");
        });
        features_filter_bar_mobile_1.FeaturesFilterBarMobile.loadClickEventForFilterButton();
        mobile_breadcrumb_1.MobileBreadcrumb.init();
        // updating filter button status
        GenericFunctions.toggleFilterButton();
        // event to scroll up when clicking a product
        ProductSearchGrid.scrollUpWhenClicked();
    };
    ProductSearchGrid.markedProductsButtonUpdateCounter = function (memberNr) {
        var numFavoriteProducts = bookmarked_products_page_1.BookMarkedProducts.loadAndGetMarkedProductsFromStorage(memberNr).length;
        if (numFavoriteProducts == 0) {
            $("#marked-products-num").hide();
        }
        else {
            $("#marked-products-num").show();
            $("#marked-products-num-value").text(numFavoriteProducts);
        }
    };
    ProductSearchGrid.isLoadNeeded = function () {
        return location.search != ProductSearchGrid.LastComponentStatus;
    };
    ProductSearchGrid.setStatus = function () {
        ProductSearchGrid.LastComponentStatus = location.search;
    };
    ProductSearchGrid.scrollUpWhenClicked = function () {
        $(".img-product-item a").on("click", function (e) {
            IframeComms.propagateHeight(true);
        });
    };
    ProductSearchGrid.productListResultsIdSelector = "#product-list-results";
    return ProductSearchGrid;
}());
exports.ProductSearchGrid = ProductSearchGrid;
